import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Form, FormField } from 'core/components';
import { InputType } from 'core/enums';
import { preventEnter } from 'core/utils';
import { IElementTemplate } from 'elements/types';

import { IUpsertElementTemplateFormData } from './types';

interface IProps {
  elementTemplate?: IElementTemplate;
  isOpen: boolean;
  onClose: (reset?: UseFormReset<IUpsertElementTemplateFormData>) => void;
  onSubmit: (
    reset: UseFormReset<IUpsertElementTemplateFormData>
  ) => (data: IUpsertElementTemplateFormData) => Promise<void>;
}

export const UpsertElementTemplateFormFields = ({
  elementTemplate,
  isOpen,
  onClose,
  onSubmit,
}: IProps) => {
  const { t } = useTranslation();

  const isEdit = !!elementTemplate?.id;

  return (
    <Form
      isOpen={isOpen}
      onClose={onClose}
      title={isEdit ? t('titleUpdateElementTemplate') : t('titleAddElementTemplate')}
      onSubmit={onSubmit}
      submitBtnLabel={isEdit ? t('buttonLabelSave') : t('buttonLabelAddElementTemplate')}
    >
      <FormField
        name="customIdentifier"
        type={InputType.TEXT_INPUT}
        inputProps={{ label: t('headerIdentifier'), required: true }}
      />

      <FormField
        name="description"
        type={InputType.TEXTAREA}
        inputProps={{
          label: t('headerDescription'),
          onKeyDown: preventEnter,
          maxRows: 6,
          required: true,
        }}
      />
    </Form>
  );
};
